import React, { useState, useEffect, useContext } from 'react';
import Auxiliary from '../../util/Auxiliary';
import axios from '../../util/Api';
import { Link } from 'react-router-dom';
import Table from '../../components/Table/Basic';
import { ParamsContext } from '../Context/ParamsContext';
import DateTime from '../../components/Formatter/DateTime';
import Date from '../../components/Formatter/Date';
import Title from '../../components/Title/Title';
import { CheckCircleFilled, CheckCircleOutlined, CloseCircleFilled, IdcardOutlined, UserAddOutlined, UserSwitchOutlined, WarningFilled } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { ADMIN } from '../../appRedux/reducers/Auth';
import { message, Tooltip } from 'antd';

const List = (props) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const params = useContext(ParamsContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(null);

  useEffect(() => {
    fetchPassport();
  },[params.sort, params.name, params.status, params.vendor, params.page, params.project]);
  
  const fetchPassport = () => {
    setLoading(true);
    const url = `/passport/list`;
    axios.get(url, { params: params }).then(resp => {
      setData(resp.data.passports);
      setTotalData(resp.data.total);
      setLoading(false);
    }).catch(err => {
      console.error(err);
      message.error("Data failed to load! please kindly refresh the page.");
    });
  }

  const columns = [
    {
      title: "Nama",
      key: 'name',
      render: record => (
        <>
          <Link to={`/passport/detail?id=${record.id}`}>
            {record.name}
          </Link>
          {record.rfid_number ? <Tooltip title="Kartu sudah dikonfigurasi"><IdcardOutlined className="gx-ml-1 gx-text-info" /></Tooltip> : null}
        </>
      ),
      sorter: true,
      filter: true,
    },
    {
      title: "Perusahaan",
      dataIndex: "vendor",
      key: 'vendor',
      render: vendor => vendor.name,
      filter: true,
      visible: authUser.role === ADMIN
    },
    {
      title: "Proyek",
      key: 'project',
      filter: true,
      render: record => record.current_project.project.name,
      visible: authUser.is_superadmin,
    },
    {
      title: "Tanggal Berakhir",
      key: 'expiry_date',
      width: '17%',
      render: record => {
        return (
          <>
            <ExpiryWarning isExpired={record.current_project.status.is_expired} days={record.current_project.days_before_expired} />
            <Date value={record.current_project.end_date} />
          </>
        );
      }
    },
    {
      title: "Dibuat",
      dataIndex: "created_at",
      key: 'created_at',
      render: created_at => <DateTime value={created_at} />,
      sorter: true,
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: 'status',
    //   sorter: true,
    //   render: status => status.label,
    //   filter: true,
    //   filterOptions: [
    //     {value: '', label: 'Semua'},
    //     {value: '10', label: 'Pending'},
    //     {value: '20', label: 'Approved'}
    //   ],
    // },
    {
      title: "Status",
      key: 'status',
      sorter: true,
      render: record => record.is_deleted ? <span className="gx-text-danger">Dihapus</span> : record.current_project.status.label,
      filter: true,
      filterOptions: [
        {value: '', label: 'Semua'},
        {value: '10', label: 'Menunggu Verifikasi'},
        {value: '5', label: 'Ditolak'},
        {value: '20', label: 'Disetujui'},
        {value: '25', label: 'Tidak Aktif'},
      ],
    },
    {
      title: '',
      width: '15%',
      render: record => (
        <div className="gx-text-right">
          {record.actions.verification ? (
            <Link to={`/passport/detail?id=${record.id}`} className="ant-btn ant-btn-primary ant-btn-sm">
              Verifikasi
            </Link>
          ) : null}
          
          {record.actions.switch_project ? <Link to={`/project/switch?id=${record.id}`} className="ant-btn ant-btn-primary ant-btn-sm"><UserSwitchOutlined /> Pindah Proyek</Link> : null}

          <Link to={`/passport/detail?id=${record.id}`} className="ant-btn ant-btn-secondary ant-btn-sm">
            Detail
          </Link>
        </div>
      )
    }
  ];

  const ExpiryWarning = ({ days, isExpired}) => {
    if (isExpired) {
      return <Tooltip title={`Kedaluwarsa (${days} hari sejak tanggal kedaluwarsa)`}><CloseCircleFilled className="gx-mr-1 gx-text-danger" /></Tooltip>;
    }
    if (days <= 30) {
      return <Tooltip title={`Tanggal berakhir kurang dari 30 hari (${days} hari)`}><WarningFilled className="gx-mr-1 gx-text-warning" /></Tooltip>;
    }

    return <Tooltip title={`${days} hari lagi sebelum berakhir`}><CheckCircleFilled className="gx-mr-1 gx-text-success" /></Tooltip>;
  }

  return (
    <Auxiliary>
      <Title>Personel Terdaftar</Title>

      {authUser.vendor ? <Link to={`/passport/register`} className="ant-btn ant-btn-primary">
        <UserAddOutlined /> Registrasi
      </Link> : null}

      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        total={totalData}
        showSorterTooltip
        pathname="/passport"
        sticky
      />
    </Auxiliary>
  );
}

export default List;